import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { Command } from 'lucide-react'
import { cn } from '@/lib/utils'

const cmdChipVariants = cva(
  'flex items-center gap-1 rounded px-2 py-0.5 text-sm',
  {
    variants: {
      variant: {
        default: 'bg-gray-500/10',
        light: 'bg-white/40',
        lighter: 'bg-white/10',
        dark: 'bg-black/10',
        white: 'bg-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface CmdChipProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof cmdChipVariants> {
  hideIcon?: boolean
}

const CmdChip = ({ children, className, hideIcon, variant }: CmdChipProps) => {
  return (
    <div className={cn(cmdChipVariants({ variant, className }))}>
      {!hideIcon && <Command className="size-3" strokeWidth={1.8} />}
      <span className="font-mono font-semibold">{children}</span>
    </div>
  )
}

export { CmdChip, cmdChipVariants }
